import { render, staticRenderFns } from "./simple-search-bar.vue?vue&type=template&id=40df3cd6&scoped=true"
import script from "./simple-search-bar.vue?vue&type=script&lang=js"
export * from "./simple-search-bar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40df3cd6",
  null
  
)

export default component.exports